import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isDarkTheme: true,
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.isDarkTheme = !state.isDarkTheme
    },
    setTheme: (state, action) => {
      state.isDarkTheme = action.payload
    },
  },
})

export const { toggleTheme, setTheme } = themeSlice.actions
export default themeSlice.reducer
